export default {
  name: "Heineken",
  favicon: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/logo.webp`,
  logo: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/logo.webp`,
  logoColor: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/logo-color.webp`,
  products: [
    {
      id: "original",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/product-forward_original.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/product-forward_original.webp`,
      },
      name: {
        en: "Original",
        fr: "Original",
      },
      description: {
        en: "Wherever you go in the world, it’s always refreshing to see something you recognize. That green bottle, the red star, the smiling ‘e’…like an instant welcome from an old friend.",
        fr: "Partout dans le monde, il est agréable de reconnaître quelque chose de rafraîchissant. La bouteille verte, l’étoile rouge, le « e » souriant… comme l’accueil spontané d’une vieille amie.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_render_bottle_330ml_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_render_bottle_330ml_original_heineken.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_nft_allrenders_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_nft_allrenders_original_heineken_fr.webp`,
          },
          name: {
            en: "Bottle 330ml",
            fr: "Bouteille 330ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_render_bottle_355ml_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_render_bottle_355ml_original_heineken.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_nft_allrenders_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_nft_allrenders_original_heineken_fr.webp`,
          },
          name: {
            en: "Bottle 355ml",
            fr: "Bouteille 355ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_render_bottle_650ml_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_render_bottle_650ml_original_heineken.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_nft_allrenders_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_nft_allrenders_original_heineken_fr.webp`,
          },
          name: {
            en: "Bottle 650ml",
            fr: "Bouteille 650ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_render_can_330ml_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_render_can_330ml_original_heineken.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_nft_allrenders_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_nft_allrenders_original_heineken_fr.webp`,
          },
          name: {
            en: "Can 330ml",
            fr: "Canette 330ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_render_can_355ml_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_render_can_355ml_original_heineken.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_nft_allrenders_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_nft_allrenders_original_heineken_fr.webp`,
          },
          name: {
            en: "Can 355ml",
            fr: "Canette 355ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_render_can_500ml_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_render_can_500ml_original_heineken.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_nft_allrenders_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_nft_allrenders_original_heineken_fr.webp`,
          },
          name: {
            en: "Can 500ml",
            fr: "Canette 500ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_render_can_710ml_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_render_can_710ml_original_heineken.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_nft_allrenders_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_nft_allrenders_original_heineken_fr.webp`,
          },
          name: {
            en: "Can 710ml",
            fr: "Canette 710ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information-render_keg_5l_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information-render_keg_5l_original_heineken.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_nft_allrenders_original_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_nft_allrenders_original_heineken_fr.webp`,
          },
          name: {
            en: "Keg 5L",
            fr: "Keg 5L",
          },
        },
      ],
    },
    {
      id: "00-alcohol",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/product-forward_00.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/product-forward_00.webp`,
      },
      name: {
        en: "0.0% Alcohol",
        fr: "0.0% Alcohol",
      },
      description: {
        en: "Heineken® 0.0 is a refreshing non-alcoholic lager, brewed with a unique recipe for a distinct balanced taste, which now allows you to enjoy a Heineken® beer at any time of day.",
        fr: "La Heineken® 0.0 est une lager sans alcool, rafraîchissante, brassée selon une recette unique pour obtenir un goût caractéristique et équilibré qui permet de savourer une bière Heineken® à n'importe quel moment de la journée.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_render_bottle_330ml_00_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_render_bottle_330ml_00_heineken.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_nft_allrenders_00_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_nft_allrenders_00_heineken_fr.webp`,
          },
          name: {
            en: "Bottle 330ml",
            fr: "Bouteille 330ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_render_can_330ml_00_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_render_can_330ml_00_heineken.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_nft_allrenders_00_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_nft_allrenders_00_heineken_fr.webp`,
          },
          name: {
            en: "Can 330ml",
            fr: "Canette 330ml",
          },
        },
      ],
    },
    {
      id: "he-silver",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/product-forward_silver.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/product-forward_silver.webp`,
      },
      name: {
        en: "Silver",
        fr: "Silver",
      },
      description: {
        en: "Heineken® Silver is brewed at a chilled -1°C, resulting in an extra-refreshing lager with a less bitter taste and a crisp, subtle finish that’s effortless to drink.",
        fr: "Heineken® Silver est brassée à -1 °C, ce qui offre une bière extrafraîche au goût moins amer et à la finale vive et subtile, qui se boit sans effort.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_render_bottle_330ml_silver_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_render_bottle_330ml_silver_heineken.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_nft_can_bottle_330ml_silver_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_nft_can_bottle_330ml_silver_heineken_fr.webp`,
          },
          name: {
            en: "Bottle 330ml",
            fr: "Bouteille 330ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_render_can_330ml_silver_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_render_can_330ml_silver_heineken.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_nft_can_bottle_330ml_silver_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_nft_can_bottle_330ml_silver_heineken_fr.webp`,
          },
          name: {
            en: "Can 330ml",
            fr: "Canette 330ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_render_can_500ml_silver_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_render_can_500ml_silver_heineken.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/en/information_nft_can_500ml_silver_heineken.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/heineken/fr/information_nft_can_500ml_silver_heineken_fr.webp`,
          },
          name: {
            en: "Can 500ml",
            fr: "Canette 500ml",
          },
        },
      ],
    },
  ],
};
